export const cadastroItems = [
  { category: "Cadastros", key: "pessoas", name: "Pessoas" },
  {
    category: "Cadastros",
    key: "produtosServicos",
    name: "Produtos e serviços",
  },
];
